/** Keep transient controls inside their owning dialog's top layer and focus scope. */
export const getOverlayContainer = (ownerArg?: Node | null): HTMLElement => {
  let node = ownerArg;
  if (ownerArg === undefined) {
    let focused = document.activeElement;
    while (focused?.shadowRoot?.activeElement) focused = focused.shadowRoot.activeElement;
    node = focused;
  }
  while (node) {
    if (node instanceof HTMLDialogElement && node.open) return node;
    node = (node instanceof Element && node.assignedSlot)
      || node.parentNode
      || (node instanceof ShadowRoot ? node.host : null);
  }
  return document.body;
};
